import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type { DashboardData } from '../model/dashboard.types';
import type { Granularity } from '../model/period';

const REQUIRED_DASHBOARD_KEYS: readonly (keyof DashboardData)[] = [
  'documentTotals',
  'activeCollaborators',
  'approvalStatus',
  'homologationLeadTime',
  'recordsManagement',
  'trainingStatus',
  'trainingTypes',
  'documentTypes',
  'trainingByDepartment',
  'activeCollaboratorsByDepartment',
];

const REQUIRED_LIST_KEYS: readonly (keyof DashboardData)[] = [
  'trainingTypes',
  'documentTypes',
  'trainingByDepartment',
  'activeCollaboratorsByDepartment',
];

function isDashboardData(payload: unknown): payload is DashboardData {
  if (payload === null || typeof payload !== 'object') return false;
  const record = payload as Record<string, unknown>;
  const hasRequiredObjects = REQUIRED_DASHBOARD_KEYS.every((key) => {
    const value = record[key];
    return typeof value === 'object' && value !== null;
  });
  if (!hasRequiredObjects) return false;
  return REQUIRED_LIST_KEYS.every((key) =>
    Array.isArray((record[key] as Record<string, unknown>).items)
  );
}

export async function getDashboard(granularity: Granularity, period: string): Promise<DashboardData> {
  const response = await api.get<ApiResponse<DashboardData>>('/dashboard', {
    params: { granularity, period },
  });
  const dashboard = response.data.data;
  if (!isDashboardData(dashboard)) {
    throw new Error('Resposta do dashboard em formato inválido');
  }
  return dashboard;
}
